import "./main-info.scss";

type MainInfoPageProps = {};

const MainInfoPage = (props: MainInfoPageProps) => {
  return (
    <>
      <div className="main-info page">
        <div className="main-info__header page__header">
          <h1 className="main-info__header__title page__header__title">
            ОБЩИ СВЕДЕНИЯ
          </h1>
        </div>
        <div className="main-info__body">
          <div className="main-info__body__content">
            <p className="main-info__body__content_item">
              Име: <strong>Евгения Асенова Арнаудова </strong>
            </p>
            <p className="main-info__body__content_item">
              Гражданство: <strong>БГ</strong>
            </p>
            <p className="main-info__body__content_item">
              Дата на раждане: <strong>16.09.1987 г. </strong>
            </p>
            <p className="main-info__body__content_item">
              Email: <strong>evgeniq_arnaudova@abv.bg</strong>
            </p>
            <p className="main-info__body__content_item">
              Служебен акаунт: <strong>evgeniia.as.petrova@edu.mon.bg</strong>
            </p>
            <p className="main-info__body__content_item">
              Телефон: <strong>0878543328 </strong>
            </p>
            <p className="main-info__body__content_item">
              Месторабота:{" "}
              <strong>II ОУ ,,Христо Смирненски”, гр. Сандански</strong>
            </p>
            <p className="main-info__body__content_item">
              Длъжност: <strong>начален учител ГЦОУД</strong>
            </p>
            <p className="main-info__body__content_item">
              Педагогически стаж: <strong>4 г. 6 мес.</strong>
            </p>
          </div>
          <div className="main-info__body__profile-pic">
            <img src="/profile-pic-2.jpg" alt="profile-pic" />
          </div>
        </div>
      </div>
      <p></p>
    </>
  );
};

export default MainInfoPage;
